/* Kiosko Negocio · comportamiento de las secciones KN Pro */
(function(){
  if (window.__knpInit) return; window.__knpInit = true;
  document.documentElement.classList.add('knp-js');

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    // Aparición al hacer scroll + barras de cifras
    var els = document.querySelectorAll('.knp-reveal');
    function show(el){
      el.classList.add('is-in');
      el.querySelectorAll('[data-knp-count]').forEach(function(n){
        if (n.__done) return; n.__done = true;
        var end = parseFloat(n.getAttribute('data-knp-count')) || 0, suf = n.getAttribute('data-knp-suffix') || '', t0 = null;
        function step(ts){ if(!t0) t0 = ts; var p = Math.min((ts - t0) / 1100, 1); n.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + suf; if (p < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
      el.querySelectorAll('.knp-bar i[data-w]').forEach(function(b){ b.style.width = b.getAttribute('data-w') + '%'; });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ show(e.target); io.unobserve(e.target); } }); }, {rootMargin:'0px 0px -10% 0px'});
      els.forEach(function(el){ io.observe(el); });
    } else { els.forEach(show); }

    // GIF livianos: se cambia la foto fija por el GIF cuando el cliente llega ahí
    var gifs = document.querySelectorAll('img[data-knp-gif]');
    function loadGif(img){ var g = img.getAttribute('data-knp-gif'); if (!g) return; img.removeAttribute('data-knp-gif'); var pre = new Image(); pre.onload = function(){ img.src = g; img.classList.add('is-gif'); }; pre.src = g; }
    if ('IntersectionObserver' in window) {
      var gio = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ loadGif(e.target); gio.unobserve(e.target); } }); }, {rootMargin:'400px 0px'});
      gifs.forEach(function(img){ gio.observe(img); });
    } else { gifs.forEach(loadGif); }

    // Pestañas
    document.querySelectorAll('[data-knp-tabs]').forEach(function(box){
      var tabs = box.querySelectorAll('.knp-tab'), panels = box.querySelectorAll('.knp-panel');
      tabs.forEach(function(t, i){ t.addEventListener('click', function(){
        tabs.forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-selected','false'); });
        panels.forEach(function(p){ p.classList.remove('is-on'); });
        t.classList.add('is-on'); t.setAttribute('aria-selected','true'); if (panels[i]) panels[i].classList.add('is-on');
      }); });
    });

    // Carruseles
    document.querySelectorAll('[data-knp-rail]').forEach(function(box){
      var rail = box.querySelector('.knp-rail'); if (!rail) return;
      box.querySelectorAll('[data-knp-dir]').forEach(function(b){ b.addEventListener('click', function(){
        var card = rail.firstElementChild; var w = card ? card.getBoundingClientRect().width + 12 : 300;
        rail.scrollBy({left: w * parseInt(b.getAttribute('data-knp-dir'), 10), behavior:'smooth'});
      }); });
    });

    // Botones que llevan al formulario de compra
    document.querySelectorAll('[data-knp-buy]').forEach(function(b){ b.addEventListener('click', function(e){
      var target = document.querySelector('variant-radios') || document.querySelector('product-info, .product__info-wrapper, [id^="MainProduct-"]');
      if (target){ e.preventDefault(); target.scrollIntoView({behavior:'smooth', block:'center'}); }
    }); });
  });
})();
